module.exports = __webpack_public_path__ + "img/sld_star_delta_transformer_t1_ba1_dark.a460fc80.svg";